import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4kwczegbw: FaireProductEntity = {
  token: "p_b4kwczegbw",
  type: "product",
  name: "Buddy Dog - Organic Jacquard Sweater Knit Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/f8a43875f4ddfd457dc3d83cd41b11a753393d2b067f538f2a38dbbba1a75f36.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4d0f2fc1363ec03339b618f090c76085789df766ea7db202ea5efd921f764f0.jpeg",
    "https://cdn.faire.com/fastly/83ce796d599a724f69a64030d00f0dd2f700903b940c93f1836a1211a7ee1cc9.jpeg",
    "https://cdn.faire.com/fastly/8a1d1595bdea2d5f1027c79ee723b742fadb054f530a4f5057f866d165aad723.jpeg",
    "https://cdn.faire.com/fastly/fdd5e17f0fd7193d05c084333cdd6ddaf9509e3a91a2fa68d5060a71a688baf1.jpeg",
    "https://cdn.faire.com/fastly/fd34ea5010e35da31203d4282502d435316506ae95aee4bb821a3b146e817ab7.jpeg",
    "https://cdn.faire.com/fastly/583c9291173542f934bb64559903a12aeb013a0cac7595ac3e95ae45050d9dd4.jpeg",
  ],
  priceDollars: 26,
  description:
    "Luxurious 100% Organic Cotton Jacquard Knitted Baby Blanket featuring cute buddy dog design.\n• Size - 30x42”.\n• Ultra-Soft, lightweight, all-season, breathable, cozy and comfy.\n• Non-toxic & natural fabrication for sensitive skin, eco-friendly & sustainable materials used.\n• Made from sustainably grown organic cotton, supporting better livelihoods of small grower farmers.\n• Conscientiously designed in USA & ethically made by artisans at a GOTS-certified facility in India.\n• Experience 'pure comfort' by Viverano, a family-owned small business.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:29.134Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
